<template>
  <div>
    <header
      class="console-header"
      :class="{ 'console-header--backstage': isBackstage }"
    >
      <div class="console-header__inner">
        <div class="console-header__brand">
          <div class="console-header__mark">RS</div>
          <div class="console-header__brand-copy">
            <span class="console-header__eyebrow">
              {{ isBackstage ? 'App Store Console' : 'Rainstore' }}
            </span>
            <a :href="`/marketplace`" class="console-header__market">
              {{ marketName }}
            </a>
          </div>
        </div>

        <div class="console-header__actions">
          <a
            v-if="!hideWorkspaceLinks"
            class="console-header__help"
            href="https://hub.grapps.cn/docs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            帮助文档
          </a>

          <div
            v-if="userInfo && userInfo.userID && enterpriseInfo"
            class="console-header__account"
          >
            <el-popover
              :offset="24"
              placement="bottom-end"
              width="320"
              trigger="hover"
            >
              <div slot="reference" class="console-header__user">
                <el-avatar
                  size="medium"
                  v-if="userInfo.picUrl"
                  :src="userInfo.picUrl"
                ></el-avatar>
                <el-avatar size="medium" v-else>
                  {{ avatarInitial }}
                </el-avatar>
                <div class="console-header__user-copy">
                  <span class="console-header__user-name">
                    {{ userInfo.realName }}
                  </span>
                  <span class="console-header__user-role">
                    {{ userRoleText }}
                  </span>
                </div>
                <i class="el-icon-arrow-down console-header__user-arrow"></i>
              </div>

              <div class="console-header__popover-section">
                <router-link
                  :to="workspaceRoute"
                  class="console-header__popover-link"
                >
                  {{ userInfo && userInfo.realName }} · 控制台
                </router-link>
                <p class="console-header__popover-meta">
                  {{ enterpriseInfo && enterpriseInfo.name }}
                </p>
              </div>

              <div class="console-header__popover-section">
                <el-tag
                  v-for="item in userInfo.roles"
                  :key="item"
                  size="mini"
                  type="info"
                  effect="plain"
                  class="console-header__role-tag"
                >
                  {{ item }}
                </el-tag>
              </div>

              <div class="console-header__popover-footer">
                <a @click="handleChangePersonalInfo">个人信息</a>
                <a @click="showChangePassword">修改密码</a>
                <a @click="enterLogin">退出登录</a>
              </div>
            </el-popover>
          </div>

          <div v-else class="console-header__guest">
            <a class="console-header__ghost-link" @click="handleLogins">登录</a>
            <a class="console-header__primary-link" @click="handleRegister">
              注册
            </a>
          </div>
        </div>
      </div>
    </header>

    <change-password
      :dialogVisible="changePasswordShow"
      :onSuccess="hideChangePassword"
      :onClose="hideChangePassword"
    ></change-password>
    <Personal
      v-if="changePersonalShow"
      v-model="changePersonalShow"
      title="修改个人信息"
    ></Personal>
  </div>
</template>

<script>
import Vue from 'vue';
import ChangePassword from './components/changePassword';
import Personal from './components/changePersonalInfo.vue';

const header = Vue.extend({
  name: 'Header',
  props: {
    tabs: {
      type: String,
      default: ''
    },
    marketDomain: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      changePasswordShow: false,
      changePersonalShow: false,
      isAdmin: window.sessionStorage.getItem('isAdmin') != 'false'
    };
  },
  components: {
    'change-password': ChangePassword,
    Personal
  },
  computed: {
    enterpriseInfo() {
      return this.$store.state.enterprise.enterpriseInfo;
    },
    marketInfo() {
      return this.$store.state.stores.marketInfo;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    isBackstage() {
      return this.tabs === 'backstage';
    },
    marketName() {
      return (this.marketInfo && this.marketInfo.name) || 'Rainstore';
    },
    hideWorkspaceLinks() {
      return this.marketInfo && this.marketInfo.keywords == 'huosy';
    },
    workspaceRoute() {
      return this.isAdmin ? { name: 'overview' } : { name: 'myOverview' };
    },
    userRoleText() {
      if (
        this.userInfo &&
        this.userInfo.roles &&
        Array.isArray(this.userInfo.roles) &&
        this.userInfo.roles.length
      ) {
        return this.userInfo.roles[0];
      }
      return '后台用户';
    },
    avatarInitial() {
      if (this.userInfo && this.userInfo.realName) {
        return this.userInfo.realName.substr(0, 1);
      }
      return 'U';
    }
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    if (!window.sessionStorage.getItem('bool')) {
      this.getUserInfoo();
    }
  },
  methods: {
    // 修改个人信息
    handleChangePersonalInfo() {
      this.changePersonalShow = true;
    },
    hideChangePassword() {
      this.changePasswordShow = false;
    },
    showChangePassword() {
      this.changePasswordShow = true;
    },
    getUserInfoo() {
      this.$store
        .dispatch('GetUserInfo')
        .then((res) => {
          if (
            res.realName == '' ||
            res.email == '' ||
            res.picUrl == '' ||
            res.phone == ''
          ) {
            this.$confirm('您的个人信息尚未完善，现在去完善？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            })
              .then(() => {
                window.sessionStorage.setItem('bool', true);
                this.changePersonalShow = true;
              })
              .catch(() => {
                window.sessionStorage.setItem('bool', true);
              });
          }
        })
        .catch((re) => {});
    },
    getUserInfo() {
      if (!this.userInfo || !this.userInfo.userID) {
        this.$store
          .dispatch('GetUserInfo')
          .then((res) => {
            if (res && res.eid) {
              this.$store.dispatch('GetEnterpriseInfo', res.eid).catch(() => {
                this.FedLogOut();
              });
              if (res.roles.indexOf('企业管理员') != -1 || res.roles.indexOf('应用管理员') != -1) {
                window.sessionStorage.setItem('isAdmin', true);
              } else {
                if (res.roles.indexOf('普通用户') != -1) {
                  window.sessionStorage.setItem('isAdmin', false);
                } else if (res.roles.indexOf('分享用户角色') != -1) {
                  window.sessionStorage.setItem('isAdmin', false);
                } else {
                  window.sessionStorage.setItem('isAdmin', true);
                }
              }
              this.isAdmin =
                window.sessionStorage.getItem('isAdmin') != 'false';
            }
          })
          .catch((re) => {
            // ignore
          });
      }
    },
    getRedirect() {
      var redirect = this.$route.fullPath;
      if (this.$route.query.redirect) {
        redirect = this.$route.query.redirect;
      }
      if (redirect == '/enterprise/login') {
        return '/manage/overview/';
      }
      return redirect;
    },
    enterLogin() {
      this.$confirm('退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          window.sessionStorage.removeItem('bool');
          this.FedLogOut();
        })
        .catch(() => {});
    },
    FedLogOut() {
      this.$store.dispatch('FedLogOut').then(() => {
        this.handleLogins();
      });
    },
    handleLogins() {
      this.$router.push({
        name: 'login'
      });
    },
    handleRegister() {
      this.$router.push({
        name: 'register'
      });
    }
  }
});

export default header;
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.console-header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1200;
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(120, 146, 176, 0.14);
  background: rgba(248, 251, 254, 0.88);
  box-shadow: 0 14px 36px rgba(61, 86, 120, 0.08);
}

.console-header--backstage {
  border-bottom-color: rgba(120, 146, 176, 0.12);
  background:
    radial-gradient(circle at top right, rgba(173, 211, 236, 0.28), transparent 32%),
    linear-gradient(180deg, rgba(250, 252, 255, 0.94) 0%, rgba(241, 247, 252, 0.94) 100%);
}

.console-header__inner {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  min-height: var(--shell-header-height, 88px);
  padding: 18px 24px;
}

.console-header__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 240px;
}

.console-header__mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: linear-gradient(135deg, #5e99cf 0%, #3a6fa7 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25);
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.console-header__brand-copy {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.console-header__eyebrow {
  color: #748aa2;
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.console-header__market {
  color: #21344c;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 0.01em;
}

.console-header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
}

.console-header__help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  padding: 0 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.72);
  color: #5f7691;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.console-header__help:hover {
  color: #284c74;
  background: rgba(220, 234, 246, 0.88);
}

.console-header__user {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 212px;
  padding: 8px 12px 8px 8px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.console-header__user:hover {
  background: rgba(220, 234, 246, 0.88);
  transform: translateY(-1px);
}

.console-header__user-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.console-header__user-name {
  color: #21344c;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.console-header__user-role {
  color: #72879d;
  font-size: 12px;
  line-height: 1.2;
}

.console-header__user-arrow {
  margin-left: auto;
  color: #7c92a8;
  font-size: 12px;
}

.console-header__popover-section {
  padding: 16px 0;
  border-bottom: 1px solid rgba(224, 230, 238, 0.9);
}

.console-header__popover-link {
  display: inline-flex;
  align-items: center;
  color: #21344d;
  font-size: 15px;
  font-weight: 600;
}

.console-header__popover-meta {
  margin-top: 6px;
  color: #708196;
  font-size: 13px;
  line-height: 1.5;
}

.console-header__role-tag {
  margin: 0 8px 8px 0;
}

.console-header__popover-footer {
  display: flex;
  padding-top: 14px;
}

.console-header__popover-footer a {
  flex: 1 1 0;
  color: #4b627e;
  font-size: 13px;
  text-align: center;
}

.console-header__popover-footer a + a {
  border-left: 1px solid rgba(224, 230, 238, 0.9);
}

.console-header__guest {
  display: flex;
  align-items: center;
  gap: 10px;
}

.console-header__ghost-link,
.console-header__primary-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 18px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.console-header__ghost-link {
  color: #315474;
  background: rgba(255, 255, 255, 0.78);
}

.console-header__primary-link {
  color: #ffffff;
  background: linear-gradient(135deg, #4d8ac5 0%, #3e74ae 100%);
}

.el-avatar {
  background: linear-gradient(135deg, #5fc7aa 0%, #2e5f96 100%);
}

::v-deep .el-avatar--medium {
  width: 40px;
  height: 40px;
  line-height: 40px;

  img {
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 1180px) {
  .console-header__inner {
    flex-wrap: wrap;
    gap: 16px;
    padding-bottom: 14px;
  }
}

@media (max-width: 768px) {
  .console-header__inner {
    padding: 16px;
  }

  .console-header__brand {
    min-width: 0;
  }

  .console-header__market {
    font-size: 20px;
  }

  .console-header__help,
  .console-header__user-copy {
    display: none;
  }

  .console-header__user {
    min-width: auto;
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue